// OfficeAddress.js
import React from 'react';

const OfficeAddress = () => {
  return (
    <div className="container mt-5 mb-5">
      <div className="row justify-content-center">
        <div className="col-md-8 text-center">
          <div className="card p-4 shadow-sm">
            <div className="card-body">
              <h4 className="card-title">Port Harcourt Office</h4>
              <p className="card-text">
                University of Rivers State<br />
                Front Gate<br />
                Mile 3
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OfficeAddress;
